import { ToTuple } from "@/types/ToTuple";

class Obj {
  public keys<T extends object, K extends keyof T>(o: T) {
    return Object.keys(o) as K[];
  }

  //

  public keysTuple<T extends Record<K, unknown>, K extends keyof T>(o: T) {
    const keys = this.keys(o) as K[];
    return keys as ToTuple<T>;
  }

  //

  public values<T extends object, K extends keyof T>(o: T) {
    return Object.values(o) as T[K][];
  }

  //

  public entries<T extends object, K extends keyof T>(o: T) {
    return (Object.entries(o) as [K, T[K]][]).map(([key, value]) => ({ key, value }));
  }

  //

  public fromEntries<Key extends string | number | symbol, Value>(entries: [Key, Value][]) {
    return Object.fromEntries(entries) as Record<Key, Value>;
  }

  //

  public fillEnum<T extends Record<string, unknown>, V>(
    enumObj: T,
    valueOrCallback: V | ((enumKey: keyof T) => V),
    keyCallback: (enumKey: T[keyof T]) => unknown = (enumKey) => enumKey,
  ) {
    return Object.fromEntries(
      this.entries(enumObj).map(({ key, value }) => [
        keyCallback(value),
        valueOrCallback instanceof Function ? valueOrCallback(key) : valueOrCallback,
      ]),
    ) as Record<keyof T, V>;
  }
}

//

export default new Obj();
